import * as React from 'react';

import { StretchBannerContainer } from '../../Banners';
import { DesktopLayout } from '../../../components/DesktopLayout';
import { AsideContainer } from '../../Aside';
import { BreadcrumbsContainer } from '../../Breadcrumbs';
import { FullscreenGalleryContainer } from '../../FullscreenGallery';
import { DesktopContentViewContainer } from '../DesktopContentView';

export const DesktopViewContainer: React.FC = () => {
  return (
    <>
      <StretchBannerContainer />
      <DesktopLayout
        breadcrumbs={<BreadcrumbsContainer />}
        content={<DesktopContentViewContainer />}
        sidebar={<AsideContainer />}
      />
      <FullscreenGalleryContainer />
    </>
  );
};
